export default function svgAllFilesIcon(classes) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={classes}
		>
			<path
				d="M12 21.75C11.665 21.75 11.371 21.528 11.279 21.206L10.5 18.479C9.807 16.054 7.945 14.192 5.521 13.5L2.79401 12.721C2.47201 12.629 2.25 12.335 2.25 12C2.25 11.665 2.47201 11.371 2.79401 11.279L5.521 10.5C7.946 9.807 9.807 7.946 10.5 5.521L11.279 2.79401C11.371 2.47201 11.665 2.25 12 2.25C12.335 2.25 12.629 2.47201 12.721 2.79401L13.5 5.521C14.193 7.946 16.055 9.808 18.479 10.5L21.206 11.279C21.528 11.371 21.75 11.665 21.75 12C21.75 12.335 21.528 12.629 21.206 12.721L18.479 13.5C16.054 14.193 14.193 16.054 13.5 18.479L12.721 21.206C12.629 21.528 12.335 21.75 12 21.75ZM5.73001 12L5.93301 12.058C8.85901 12.894 11.106 15.141 11.943 18.068L12.001 18.27L12.059 18.068C12.896 15.141 15.142 12.895 18.069 12.058L18.27 12L18.067 11.942C15.141 11.106 12.894 8.85901 12.057 5.93201L12 5.73099L11.942 5.93301C11.105 8.86001 8.85901 11.106 5.93201 11.943L5.73001 12Z"
				fill="currentColor"
			/>
		</svg>
	);
}
